import { useState, useEffect } from 'react';
import {generateClient} from 'aws-amplify/data';
import {Button, Collection, Divider, Flex, useTheme, View} from '@aws-amplify/ui-react';
import BreakCard from "./BreakCard";

interface BreakItem {
    id: string;
    name?: string | null;
    description?: string | null;
    createdAt: string;
    updatedAt: string;
    owner?: string;
}

export default function EditPage() {
    const {tokens} = useTheme();

    const [breakItems, setBreakItems] = useState<BreakItem[]>([]);

    // Create client lazily when needed
    const getClient = () => {
        const client = generateClient();
        return client as any; // Type assertion to bypass TypeScript issues
    };

    useEffect(() => {
        const subscription = getClient().models.BreakItem.observeQuery().subscribe({
            next: ({ items }: { items: BreakItem[] }) => {
                const sortedItems = [...items].sort((a, b) => {
                    if (a.createdAt == null) return -1;
                    else if (b.createdAt == null) return 1;
                    else return new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime();
                });
                setBreakItems(sortedItems);
            }
        });

        return () => subscription.unsubscribe();
    }, []);

    const createBreakItem = async () => {
        try {
            await getClient().models.BreakItem.create({
                name: "Name",
                description: "Description"
            });
        } catch (err) {
            console.log('error creating breakItem:', err)
        }
    }

    const BreakCardCollection = () => {
        return (
            <View>
                <View marginTop={tokens.space.medium} marginBottom={tokens.space.large}>
                    <Divider/>
                </View>
                <Collection
                    type="list"
                    direction="column"
                    alignItems="center"
                    items={breakItems}
                >
                    {(item, _) => (
                        <View width="100%" key={item.id}>
                            <BreakCard
                                breakItem={item}
                                isEditable={true}
                            />
                        </View>
                    )}
                </Collection>
            </View>
        )
    }

    return <View
        margin="20px auto"
        borderRadius="10px"
        padding={tokens.space.medium}
        backgroundColor={tokens.colors.background.secondary}
    >
        <Flex
            direction="column"
            maxWidth="400px"
            margin="0 auto"
        >
            <Button onClick={() => createBreakItem()}>Add Break Activity</Button>
            <BreakCardCollection/>
        </Flex>
    </View>
}